<script setup lang="ts">
import { GpTag } from '@gportal/uikit';
import type { Datacenter } from 'gpcore-grpc/gpcore/api/cloud/v1/region_pb';
import DatacenterBadge from 'gpcore-uikit/components/Component.Badge.Datacenter.vue';
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    datacenter: Datacenter;

    latency?: number;

    isComingSoon?: boolean;
    isAllDatacentersAvailable?: boolean;
  }>(),
  {
    latency: null,
    isComingSoon: false,
    isAllDatacentersAvailable: false,
  },
);

const latencyLevel = computed(() => {
  if (props.latency == null) {
    return 'neutral';
  }

  if (props.latency < 50) {
    return 'success';
  }

  if (props.latency < 100) {
    return 'warning';
  }

  return 'danger';
});
</script>

<template>
  <div class="tw-px-4 tw-pb-4">
    <p class="tw-mb-2 tw-text-xl">
      <DatacenterBadge class="tw-font-bold" :datacenter="datacenter" />
    </p>
    {{ datacenter.short }} - {{ datacenter.name }}
    <br />
    <transition name="fade" mode="out-in">
      <GpTag v-if="latency != null" :key="`latency_${latency}`" size="xs" :tag-type="latencyLevel">
        {{ latency }}ms
      </GpTag>
    </transition>
  </div>
</template>
